import { Store, Dispatch, MiddlewareAPI, Action, Middleware } from "redux";

export interface PAction extends Action {
  payload?: any | null;
}

export class StoreLogger {
  store: Store | null = null;
  constructor(store: Store) {
    this.store = store;
  }
  log = <A extends PAction>(action: A) => {
    console.log("Action type:", action.type);
    console.log("Action payload:", action?.payload);
    console.log("State before:", this.store?.getState());
    console.log("State after:", this.store?.getState());
  };
}

function loggerMiddleware(api: MiddlewareAPI<any>) {
  return (next: Dispatch<any>) =>
    <A extends Action>(action: A) => {
      const logger = new StoreLogger(api as Store);
      logger.log(action);
      next(action);
    };
}

export default loggerMiddleware as Middleware;
